import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';
import { COUNTRY_ID } from '@src/constants/URLS.const';
const StoreCountries = lazy(() => import('@src/pages/store/StoreCountries'));
const CountryDetails = lazy(() => import('@src/pages/store/CountryDetails'));

export default function StoreContainer() {
    return (
        <Routes>
            <Route index element={<LazyLoadComponent Component={<StoreCountries />} type="PAGE" />} />
            <Route path={COUNTRY_ID} element={<LazyLoadComponent Component={<CountryDetails />} type="PAGE" />} />
        </Routes>
    );
}